import React from 'react';
import { Toaster } from '../ui';
import Header from './Header';
import Sidebar from './Sidebar';

/**
 * Page frame layout (LLMTalk-style): fixed top nav + sidebar + main content.
 * - TopNav: fixed top-0, h-11, full width
 * - Body: flex row with pt-11, containing Sidebar + main (flex-1 overflow-hidden)
 */
function RootLayout({
  children,
  sidebarOpen,
  setSidebarOpen,
  activeService,
  setActiveService,
  synopsisExpanded,
  setSynopsisExpanded,
  keywordExpanded,
  setKeywordExpanded,
  transcriptionExpanded,
  setTranscriptionExpanded,
  setShowProjectDetailPage,
  setSelectedProject,
  setSynopsisProjectDetails,
  user,
  showUserDropdown,
  setShowUserDropdown,
  logout,
  logoutLoading,
  showSidebar = true,
}) {
  return (
    <div className="bg-surface flex h-screen w-full flex-col overflow-hidden">
      <Toaster />
      <Header
        user={user}
        showUserDropdown={showUserDropdown}
        setShowUserDropdown={setShowUserDropdown}
        setSidebarOpen={setSidebarOpen}
        logout={logout}
        logoutLoading={logoutLoading}
      />
      <div className="flex flex-1 flex-row overflow-hidden pt-11">
        {showSidebar && (
          <Sidebar
            sidebarOpen={sidebarOpen}
            setSidebarOpen={setSidebarOpen}
            activeService={activeService}
            setActiveService={setActiveService}
            synopsisExpanded={synopsisExpanded}
            setSynopsisExpanded={setSynopsisExpanded}
            keywordExpanded={keywordExpanded}
            setKeywordExpanded={setKeywordExpanded}
            transcriptionExpanded={transcriptionExpanded}
            setTranscriptionExpanded={setTranscriptionExpanded}
            setShowProjectDetailPage={setShowProjectDetailPage}
            setSelectedProject={setSelectedProject}
            setSynopsisProjectDetails={setSynopsisProjectDetails}
            user={user}
          />
        )}
        <main className="flex min-w-0 flex-1 flex-col overflow-hidden">
          <div class="flex flex-row gap-0 justify-start items-start flex-1 overflow-hidden">
            <div class="flex w-full py-1 pr-1">
              <div class="relative flex flex-1 flex-row h-[calc(95dvh)] border border-border rounded-sm bg-secondary w-full overflow-hidden shadow-sm">
                {children}
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}

export default RootLayout;
